import {
    BAD_REQUEST_400,
    BAD_REQUEST_400_TITLE,
    FORBIDDEN_403,
    FORBIDDEN_403_TITLE,
    INTERNAL_SERVER_ERROR_500,
    INTERNAL_SERVER_ERROR_500_TITLE,
    NOT_FOUND_404,
    NOT_FOUND_404_TITLE,
    UNAUTHORISED_401,
    UNAUTHORISED_401_TITLE,
  } from "../constants/errors";
  
  const handleReturnedError = (err:any, reject:any) => {
    // OVERALL LOGIC
    // if there is no body, then show a MODAL
    // if there IS a body.....
    // if the status code is 401, 404, 500 then show modal,
    // else show alert
  
    const bodyExists = err.response?.data;
    const responseURL = err.response?.request?.responseURL;
    const status = err.response?.status;
  
    let errorTitle;
  
    if (status === BAD_REQUEST_400) {
      errorTitle = BAD_REQUEST_400_TITLE;
    } else if (status === UNAUTHORISED_401) {
      errorTitle = UNAUTHORISED_401_TITLE;
    } else if (status === FORBIDDEN_403) {
      errorTitle = FORBIDDEN_403_TITLE;
    } else if (status === NOT_FOUND_404) {
      errorTitle = NOT_FOUND_404_TITLE;
    } else if (status === INTERNAL_SERVER_ERROR_500) {
      errorTitle = INTERNAL_SERVER_ERROR_500_TITLE;
    }
  
    // There is NO body ----->
  
    if (!bodyExists) {
      // There is NO body so, bad error, show modal
      reject({
        statusCode: status,
        title: errorTitle,
        responseURL: responseURL,
      });
    } else {
      // There IS a body ----->
      const errorMessage = err.response?.data?.message;
  
      reject({
        statusCode: status,
        title: errorTitle,
        message: errorMessage,
        responseURL: responseURL,
      });
    }
  };
  
  export { handleReturnedError };
  